"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@8base/utils");
const auth_1 = require("@8base/auth");
const AuthContext_1 = require("./AuthContext");
/**
 * Provides access to the authentication state.
 * @property {React$Node} children Children of the provider.
 * @property {IAuthClient} authClient Instance of the auth client.
 */
class AuthProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.updateState = () => {
            const { authClient } = this.props;
            const authState = authClient.getState();
            const isAuthorized = authClient.checkIsAuthorized();
            const isEmailVerified = authClient.checkIsEmailVerified && authClient.checkIsEmailVerified();
            this.setState({ isAuthorized, isEmailVerified, authState });
        };
        if (props.authClient === undefined || props.authClient === null) {
            throw new utils_1.SDKError(utils_1.ERROR_CODES.MISSING_PARAMETER, utils_1.PACKAGES.REACT_AUTH, 'Property authClient in the AuthProvider should be specified');
        }
        if (!auth_1.SubscribableDecorator.hasConflicts(props.authClient)) {
            throw new utils_1.SDKError(utils_1.ERROR_CODES.INVALID_ARGUMENT, utils_1.PACKAGES.REACT_AUTH, 'authClient should has ability to notify about state changes');
        }
        this.state = {
            authState: {},
            isAuthorized: false,
        };
        this.unsubscribe = null;
    }
    componentDidMount() {
        this.unsubscribe = this.props.authClient.subscribe(() => {
            this.updateState();
        });
        this.updateState();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.authClient !== this.props.authClient) {
            this.unsubscribe = this.props.authClient.subscribe(() => {
                this.updateState();
            });
        }
    }
    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }
    render() {
        const { children, authClient } = this.props;
        const { isAuthorized, isEmailVerified, authState } = this.state;
        return (react_1.default.createElement(AuthContext_1.AuthContext.Provider, { value: {
                authClient,
                authState,
                isAuthorized,
                isEmailVerified,
            } }, children));
    }
}
exports.AuthProvider = AuthProvider;
//# sourceMappingURL=AuthProvider.js.map